import { apiClient } from '@/lib/api/client'

export type TicketOption = {
  code: string
  label: string
}

type TicketOptionApiRow = {
  code?: string
  label?: string | null
  active?: boolean
}

function normalizeRows(payload: unknown): TicketOptionApiRow[] {
  if (Array.isArray(payload)) return payload as TicketOptionApiRow[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: TicketOptionApiRow[] }).data
  }
  return []
}

export async function getOptionsByGroup(groupCode: string): Promise<TicketOption[]> {
  const { data } = await apiClient.get<unknown>(`/options/ticket-option-lists/${groupCode}`)
  return normalizeRows(data)
    .filter((row) => row?.code)
    .filter((row) => row.active !== false)
    .map((row) => ({
      code: String(row.code ?? ''),
      label: String(row.label?.trim() || row.code || ''),
    }))
}

export function optionCodes(options: TicketOption[]): string[] {
  return options.map((o) => o.code)
}
